import React from 'react';
import { IEvaluation } from '@/lib/evaluationsApi';
import * as Styled from './styled';
import { Row } from '@/ui/primatives';
import Button from '@/ui/Button';
import * as Icon from '@/ui/Icon';
import { hasBranchAdvanced } from '../../../lib';
import { LayersIcon } from '@radix-ui/react-icons';
import { TargetFileInfo } from '../../EvaluationFileInfo';
import { IRepository, ICommit } from '@/types';

const getOutputFileUrl = (evaluation: IEvaluation, repository: IRepository, closingCommit?: ICommit | null) => {
  const baseUrl = `/${repository.namespace}/${repository.name}/file`;
  const isBranchAdvanced = hasBranchAdvanced(evaluation, repository);
  const fileAtCommitUrl = closingCommit && `${baseUrl}/${closingCommit.id}/${evaluation.target_path}`;
  const fileAtBranchUrl = `${baseUrl}/${evaluation.target_branch}/${evaluation.target_path}`;
  return isBranchAdvanced ? fileAtCommitUrl : fileAtBranchUrl;
};

const OutputFileInfo: React.FC<{ evaluation: IEvaluation; repository: IRepository }> = ({ evaluation, repository }) => {
  const closingCommit = evaluation.closing_commit || evaluation.workspace?.closing_commit;
  const fileInWorkspaceUrl = `/${repository.namespace}/${repository.name}/workspaces/${evaluation.workspace?.id}/file/${evaluation.target_path}`;
  const outputFileUrl = getOutputFileUrl(evaluation, repository, closingCommit);

  return (
    <Styled.OutputFileInfo>
      <TargetFileInfo evaluation={evaluation} repository={repository} />
      {closingCommit ? (
        <Row gap={20} alignItems="center">
          <Button.Basic
            smaller
            data-tutorialid="view-file-diff"
            className="nowrap link-underline"
            href={`/${repository.namespace}/${repository.name}/compare/file/${evaluation.commit_id}..${closingCommit.id}/${evaluation.target_path}`}
          >
            <Icon.Compare />
            View changes
          </Button.Basic>
          <Button.Basic
            smaller
            className="nowrap link-underline"
            data-tutorialid="view-file-at-commit"
            href={outputFileUrl as string}
          >
            <Icon.Commit />
            View file at commit
          </Button.Basic>
        </Row>
      ) : (
        <Button.Basic
          smaller
          className="nowrap link-underline"
          data-tutorialid="view-file-in-workspace"
          href={fileInWorkspaceUrl}
        >
          <LayersIcon />
          View file in workspace
        </Button.Basic>
      )}
    </Styled.OutputFileInfo>
  );
};

export default OutputFileInfo;
